<script>
import AdminLayout from '@layouts/admin-main'
import BrokerageBalanceList from '@components/admin/brokerage-balance-list'
import BrokerageNav from '@components/admin/brokerage-nav'

export default {
  page: {
    title: 'Admin::BrokerageCatalogBalanceList',
    meta: [
      { name: 'description', content: 'Admin::BrokerageCatalogBalanceList' },
    ],
  },
  components: { AdminLayout, BrokerageBalanceList, BrokerageNav },
}
</script>

<template>
  <AdminLayout>
    <BrokerageNav></BrokerageNav>
    <BrokerageBalanceList></BrokerageBalanceList>
  </AdminLayout>
</template>
